import { render, staticRenderFns } from "./PaginateTableNoPage.vue?vue&type=template&id=0a11bf34&scoped=true&"
import script from "./PaginateTableNoPage.vue?vue&type=script&lang=js&"
export * from "./PaginateTableNoPage.vue?vue&type=script&lang=js&"
import style0 from "./PaginateTableNoPage.vue?vue&type=style&index=0&id=0a11bf34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a11bf34",
  null
  
)

export default component.exports